module.exports = __webpack_public_path__ + "static/media/arialbd.858f5a50.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/components/project/sections/LeasingComponents/BrineTemplates/arialbd.ttf
// module id = 2695
// module chunks = 0